/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './user-managment-main.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../navbar/navbar.component.ngfactory';
import * as i3 from '../../../../../../../app/components/navbar/navbar.component';
import * as i4 from '@angular/router';
import * as i5 from '../../../../../../../app/shared/_services/login.service';
import * as i6 from '@ngx-translate/core/src/translate.service';
import * as i7 from '../../../../../../../app/shared/_services/hca-user-management.service';
import * as i8 from '../../../../../../../app/shared/_services/util.service';
import * as i9 from '../../../../../../../app/components/admin/lsa-admin/user-management/user-managment-main/user-managment-main.component';
const styles_UserManagmentMainComponent:any[] = [i0.styles];
export const RenderType_UserManagmentMainComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_UserManagmentMainComponent,data:{}});
export function View_UserManagmentMainComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-navbar',
      ([] as any[]),(null as any),(null as any),(null as any),i2.View_NavbarComponent_0,
      i2.RenderType_NavbarComponent)),i1.ɵdid(1,114688,(null as any),0,i3.NavbarComponent,
      [i4.Router,i5.LoginService,i6.TranslateService,i7.HcaUserManagementService,i8.UtilService],
      (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),
      i1.ɵeld(3,16777216,(null as any),(null as any),1,'router-outlet',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(4,212992,(null as any),0,i4.RouterOutlet,[i4.ChildrenOutletContexts,
          i1.ViewContainerRef,i1.ComponentFactoryResolver,[8,(null as any)],i1.ChangeDetectorRef],
          (null as any),(null as any)),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        _ck(_v,1,0);
        _ck(_v,4,0);
      },(null as any));
}
export function View_UserManagmentMainComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-user-managment-main',
      ([] as any[]),(null as any),(null as any),(null as any),View_UserManagmentMainComponent_0,
      RenderType_UserManagmentMainComponent)),i1.ɵdid(1,114688,(null as any),0,i9.UserManagmentMainComponent,
      ([] as any[]),(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const UserManagmentMainComponentNgFactory:i1.ComponentFactory<i9.UserManagmentMainComponent> = i1.ɵccf('app-user-managment-main',
    i9.UserManagmentMainComponent,View_UserManagmentMainComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vbHNhLWFkbWluL3VzZXItbWFuYWdlbWVudC91c2VyLW1hbmFnbWVudC1tYWluL3VzZXItbWFuYWdtZW50LW1haW4uY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vbHNhLWFkbWluL3VzZXItbWFuYWdlbWVudC91c2VyLW1hbmFnbWVudC1tYWluL3VzZXItbWFuYWdtZW50LW1haW4uY29tcG9uZW50LnRzIiwibmc6Ly8vYXBwL3NyYy9hcHAvY29tcG9uZW50cy9hZG1pbi9sc2EtYWRtaW4vdXNlci1tYW5hZ2VtZW50L3VzZXItbWFuYWdtZW50LW1haW4vdXNlci1tYW5hZ21lbnQtbWFpbi5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvYWRtaW4vbHNhLWFkbWluL3VzZXItbWFuYWdlbWVudC91c2VyLW1hbmFnbWVudC1tYWluL3VzZXItbWFuYWdtZW50LW1haW4uY29tcG9uZW50LnRzLlVzZXJNYW5hZ21lbnRNYWluQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGFwcC1uYXZiYXI+PC9hcHAtbmF2YmFyPlxuPHJvdXRlci1vdXRsZXQ+PC9yb3V0ZXItb3V0bGV0PlxuIiwiPGFwcC11c2VyLW1hbmFnbWVudC1tYWluPjwvYXBwLXVzZXItbWFuYWdtZW50LW1haW4+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO21DQUFBLFVBQUE7TUFBQTtNQUFBLDZCQUF5QiwwQ0FDekI7YUFBQTtVQUFBO2FBQUE7MERBQUE7VUFBQSw2QkFBK0I7O1FBRC9CO1FBQ0E7Ozs7b0JDREE7TUFBQTsyQ0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/admin/lsa-admin/user-management/user-managment-main/user-managment-main.component.ngfactory.ts